'use strict';
var app = require('angular').module('dashboard');
app.factory('gridConfiguration', ['$state', '$serverData', '$compile', '$translate', 'siteConfig', 'toast', require('../gridFactory')]);
app.controller('dashboardTasksAdvancedCtrl', ['$uibModal','$state','$scope', 'departments','dialog','Department','myTenant','toast', 'gridConfiguration','$translate', require('./dashboardTasksAdvancedCtrl')]);
app.controller('dashboardTasksAdvancedImportsCtrl', ['$uibModal','$state','$scope', 'departments','dialog','Department','myTenant','toast', 'gridConfiguration','$translate', require('./dashboardTasksAdvancedImportsCtrl')]);
app.config(['$stateProvider', require('./dashboardTasksAdvancedConfig')]);
app.directive('onReadFile', ['$parse',function ($parse) {
	return {
		restrict: 'A',
		scope: false,
		link: function(scope, element, attrs) {
            var fn = $parse(attrs.onReadFile);
            
			element.on('change', function(onChangeEvent) {
				var reader = new FileReader();                
				reader.onload = function(onLoadEvent) {
					scope.$apply(function() {
						fn(scope, {$fileContent:onLoadEvent.target.result});
					});
				};
				reader.readAsText((onChangeEvent.target).files[0]);
			});
		}
	};
}]);
app.controller('importCtrl1', ['$state','$scope', 'dialog', '$translate', require('./import/1.js')]);
app.controller('importCtrl2', ['$state','$scope', 'Department', require('./import/2.js')]);
app.controller('importCtrl3', ['$state','$scope','Department', 'Client', 'Member', 'toast', require('./import/3.js')]);

app.directive('import1b', [require('./imports/1b.js')]);
app.directive('import2b', [require('./imports/2b.js')]);
app.directive('import3b', [require('./imports/3b.js')]);

app.directive('autoimport', [require('./imports/autoImport.js')]);